<template>
  <div>
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <div class="menu_style">
      <van-form>
        <div>
          <van-field v-model="familyVO.firstName" label="姓" />
          <van-field v-model="familyVO.lastName" label="名" />
        </div>
        <div style="margin-top: 11px">
          <van-field
            readonly
            clickable
            :value="familyVO.sex"
            label="性别"
            @click="sex_show = true"
          />
          <van-popup
            v-model="sex_show"
            round
            position="bottom"
            :style="{ height: '40%' }"
          >
            <van-picker
              title="性别"
              show-toolbar
              :columns="sex_columns"
              @confirm="sex_confirm"
              @cancel="sex_cancel"
            />
          </van-popup>
          <van-field
            readonly
            clickable
            :value="familyVO.born"
            label="出生日期"
            @click="born_show = true"
          />
          <van-popup
            v-model="born_show"
            round
            position="bottom"
            :style="{ height: '40%' }"
          >
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="选择出生日期"
              :min-date="minDate"
              @confirm="born_confirm"
              @cancel="born_cancel"
          /></van-popup>
          <van-field
            v-model="familyVO.cardId"
            label="身份证"
            placeholder="(通关需要)"
          />
        </div>

        <div v-if="master == 1" style="margin-top: 11px">
          <van-field
            readonly
            clickable
            :value="familyVO.cgmAddress.province_city_district"
            label="省市区"
            @click="province_city_district_show = true"
          />
          <van-popup
            v-model="province_city_district_show"
            round
            position="bottom"
            :style="{ height: '40%' }"
          >
            <van-area
              title="省市区"
              :area-list="areaList"
              @confirm="address_confirm"
              @cancel="address_cancel"
            />
          </van-popup>
          <van-field v-model="familyVO.cgmAddress.address" label="地址" />
        </div>
        <div style="margin-top: 40px">
          <van-button block type="danger" @click="user_self_click"
            >完成</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { Toast } from "vant";
import { areaList } from "@vant/area-data";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      areaList,
      sex_show: false,
      sex_columns: ["男", "女"],
      born_show: false,
      province_city_district_show: false,
      minDate: new Date(1950, 0, 1),
      currentDate: new Date(1980, 0, 1),
      familyVO: {
        userId: null,
        familyId: this.$route.query.familyId,
        firstName: null,
        lastName: null,
        born: null,
        sex: null,
        cardId: null,
        cgmAddress: {
          addressId: null,
          province: null,
          city: null,
          district: null,
          province_city_district: null,
          address: null,
        },
      },
      master: null,
    };
  },
  mounted() {
    this.axios
      .get("/cgmFamily/getInfo", {
        params: {
          familyId: this.$route.query.familyId,
        },
      })
      .then((res) => {
        if (res.data.code == 200) {
          this.familyVO.firstName = res.data.data.firstName;
          this.familyVO.lastName = res.data.data.lastName;
          this.familyVO.born = res.data.data.born;
          this.familyVO.sex = res.data.data.sex;
          this.familyVO.cardId = res.data.data.cardId;

          this.master = res.data.data.master;

          if (res.data.data.cgmAddress != null) {
            this.familyVO.cgmAddress.addressId =
              res.data.data.cgmAddress.addressId;

            this.familyVO.cgmAddress.province =
              res.data.data.cgmAddress.province;
            this.familyVO.cgmAddress.city = res.data.data.cgmAddress.city;
            this.familyVO.cgmAddress.district =
              res.data.data.cgmAddress.district;

            this.familyVO.cgmAddress.province_city_district =
              res.data.data.cgmAddress.province +
              res.data.data.cgmAddress.city +
              res.data.data.cgmAddress.district;

            this.familyVO.cgmAddress.address = res.data.data.cgmAddress.address;
          }
        }
      });
  },
  methods: {
    user_self_click() {
      if (this.familyVO.firstName == null || this.familyVO.firstName == "") {
        Toast.success("请填写姓");
        return;
      }
      if (this.familyVO.lastName == null || this.familyVO.lastName == "") {
        Toast.success("请填写名");
        return;
      }
      if (this.familyVO.born == null || this.familyVO.born == "") {
        Toast.success("请选择出生日期");
        return;
      }
      if (this.familyVO.sex == null || this.familyVO.sex == "") {
        Toast.success("请选择性别");
        return;
      }
      if (
        this.familyVO.cgmAddress.province == null ||
        this.familyVO.cgmAddress.province == ""
      ) {
        Toast.success("请选择省市区");
        return;
      }
      if (
        this.familyVO.cgmAddress.address == null ||
        this.familyVO.cgmAddress.address == ""
      ) {
        Toast.success("请输入详细地址");
        return;
      }

      let userId = JSON.parse(this.cgmUserVO).userId;
      this.familyVO.cgmAddress.userId = userId;
      this.axios.put("/cgmFamily/update", this.familyVO).then((res) => {
        if (res.data.code == 200) {
          this.$router.push({
            path: "/menu",
          });
          Toast.success("已修改");
        }
      });
    },
    sex_confirm(v) {
      this.familyVO.sex = v;
      this.sex_show = false;
    },
    born_confirm() {
      this.familyVO.born = this.timeFormat(this.currentDate);
      this.born_show = false;
    },
    address_confirm(v) {
      this.familyVO.cgmAddress.province = v[0].name;
      this.familyVO.cgmAddress.city = v[1].name;
      this.familyVO.cgmAddress.district = v[2].name;
      this.familyVO.cgmAddress.province_city_district =
        v[0].name + v[1].name + v[2].name;
      this.province_city_district_show = false;
    },
    sex_cancel() {
      this.sex_show = false;
    },
    born_cancel() {
      this.born_show = false;
    },
    address_cancel() {
      this.province_city_district_show = false;
    },
    timeFormat(time) {
      let year = time.getFullYear();
      let month = String(time.getMonth() + 1).padStart(2, "0");
      let day = String(time.getDate()).padStart(2, "0");
      return year + "-" + month + "-" + day;
    },
    onClickLeft() {
      this.$router.push({
        path: "/menu",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .van-radio--horizontal {
  margin-right: unset !important;
}
::v-deep .van-field__control {
  text-align: right !important;
}
.sex_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  color: #646566;
  font-size: 14px;
  line-height: 24px;
  background: #fff;
}
.man_style {
  margin-bottom: 4px;
}
.menu_style {
  background: #f5f6f8;
  padding: 19px 15px 45px 15px;
}
.card_style1 {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 45px;
}
.layout_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px 20px 10px;
}
.border_style {
  border-bottom: 1px solid #e5e9f0;
}
.title_style {
  color: #202f3b;
  font-size: 16px;
  font-weight: bold;
}
</style>